import {API, graphqlOperation} from "aws-amplify";
import {updateJourneyMap, updateMap} from "./mutations";
import {getJourneyMap, getMapMeta as getMapMetaApi} from "./queries";
import {GetJourneyMapQuery, GetMapMetaQuery} from "../API";
import {MAP_VERSION1, MapMeta as ModelMapMeta} from "../models/MapMeta";

export function updateMapTitle(map_id: string, title: string) {
    return API.graphql(graphqlOperation(
        updateMap, {
            mapId: map_id,
            title: title,
        }
    ));
}

export function updateMapPreview(map_id: string, preview: string) {
    return API.graphql(graphqlOperation(
        updateMap, {
            mapId: map_id,
            preview: preview,
        }
    ));
}

export function updateMapVersion(map_id: string, version: number) {
    return API.graphql(graphqlOperation(
        updateJourneyMap, {
            input: {
                id: map_id,
                version: version,
            }
        }
    ));
}


export async function getMapVersion(map_id: string) {
    const map = await API.graphql(graphqlOperation(
        getJourneyMap, {
            id: map_id,
        }
    )) as { data: GetJourneyMapQuery };

    const version = map.data.getJourneyMap?.version;
    return version === null ? MAP_VERSION1 : version;
}


export async function getMapMeta(map_id: string): Promise<ModelMapMeta> {
    const res = await API.graphql(graphqlOperation(
        getMapMetaApi, {
            mapId: map_id,
        }
    )) as { data: GetMapMetaQuery };

    if (!res.data.getMapMeta) {
        throw  new Error("getMapMeta failed");
    }
    return ModelMapMeta.fromApi(res.data.getMapMeta);

}
